module.exports = __webpack_public_path__ + "static/media/card-logo-unknown.62b403ca.svg";